import { buildWorkoutProfile } from "@/lib/workoutProfile";

export const WorkoutProfile = ({ template, height = 56, testId = "workout-profile" }) => {
  const segments = buildWorkoutProfile(template);
  let cursor = 0;
  return (
    <svg
      viewBox="0 0 100 100"
      width="100%"
      height={height}
      role="img"
      aria-label="Workout profile"
      data-testid={testId}
      className="block w-full bg-dark-surface-2"
    >
      {segments.map((segment, index) => {
        const x = cursor * 100;
        const width = Math.max(segment.width * 100, 0.4);
        cursor += segment.width;
        const barHeight = Math.max(8, Math.min(92, segment.height));
        return (
          <rect
            key={`${segment.role}-${index}`}
            x={x}
            y={96 - barHeight}
            width={width}
            height={barHeight}
            fill={segment.color}
            data-step-role={segment.role}
          />
        );
      })}
    </svg>
  );
};
